import type { WebCategory } from "../api/types"

/**
 * Плоский указатель по дереву веб-категорий.
 *
 * Категории группы приходят одними идентификаторами (`product-group-cats`
 * отдаёт путь числами, `group-catalogs` — вообще одну категорию строкой), а
 * названия живут только в дереве. Один проход — и дальше можно и назвать
 * категорию, и построить путь до корня.
 */
export function indexCategories(roots: WebCategory[]) {
	const names = new Map<number, string>()
	const parents = new Map<number, number>()
	let leaves = 0

	const walk = (nodes: WebCategory[], parent?: number) => {
		for (const node of nodes) {
			names.set(node.id, node.name)
			if (parent !== undefined) parents.set(node.id, parent)
			if (node.children.length === 0) leaves++
			else walk(node.children, node.id)
		}
	}
	walk(roots)

	return { names, parents, leaves }
}

/** Путь до категории названиями, сверху вниз. Неизвестный узел показываем
 *  идентификатором, а не прячем: так видно, что дерево и группа разошлись. */
export function categoryPath(
	id: number,
	{ names, parents }: { names: Map<number, string>; parents: Map<number, number> }
): string[] {
	const parts: string[] = []
	let at: number | undefined = id
	// дерево неглубокое (три уровня), но от порчи данных страхуемся счётчиком
	for (let step = 0; at !== undefined && step < 20; step++) {
		parts.unshift(names.get(at) ?? `#${at}`)
		at = parents.get(at)
	}
	return parts
}
